import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DefaultIcon } from '@summit/core';
import { MenuItem } from 'primeng/api';
import { Button } from 'primeng/button';
import { Divider } from 'primeng/divider';
import { TieredMenu } from 'primeng/tieredmenu';
@Component({
  selector: 's-ui-menubar',
  templateUrl: './s-ui-menubar.component.html',
  styleUrls: ['./s-ui-menubar.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [Button, Divider, TieredMenu]
})
export class SUiMenubarComponent implements OnInit {
  @Input() model: MenuItem[];
  @Input() gap: number;
  defaultIcon = DefaultIcon;
  @Output() itemClick: EventEmitter<any> = new EventEmitter();

  constructor() {}

  ngOnInit() {}

  onItemClick(event: any, processedItem: any) {
    event.stopPropagation();
    event.preventDefault();
    //console.log('onItemClick', event, processedItem);
    if (processedItem.disabled) {
      return;
    }
    if (processedItem.command) {
      if (processedItem.command instanceof Function) {
        processedItem.command({ originalEvent: event, item: processedItem.item });
      } else if (processedItem.command instanceof Object) {
        processedItem.command.execute({ originalEvent: event, item: processedItem.item });
      }
    }
  }
  // getItemProp(processedItem: any, name: string, params: any | null = null) {
  //   return processedItem && processedItem.item ? resolve(processedItem.item[name], params) : undefined;
  // }
}
